const initCheckboxSingleUnchecked = (form) => {
	const checkboxes = form.element.querySelectorAll('[data-checkbox-single-unchecked-id]');
	if (!checkboxes.length) return;

	const processCheckboxes = (event) => {
		const checkbox = event.target;
		const uncheckedId = checkbox.dataset.checkboxSingleUncheckedId;
		const uncheckedValue = form.element.querySelector(`#${uncheckedId}`);
		if (!uncheckedValue) return;
		uncheckedValue.disabled = checkbox.checked;
	};

	checkboxes.forEach(checkbox => {
		processCheckboxes({ target: checkbox });
		checkbox.addEventListener('change', processCheckboxes);
	});
};

export default initCheckboxSingleUnchecked;